import "./__tabs.scss"; import "./soft_tab_content_module.scss"

